import React from 'react'

export const highlightText = (text, searchTerm) => {
  if (!searchTerm) return text

  const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'))
  return parts.map((part, index) =>
    part.toLowerCase() === searchTerm.toLowerCase() ? (
      <span key={index} className="highlighted_text">
        {part}
      </span>
    ) : (
      part
    )
  )
}
